import http from './http'
import { getToken } from './auth'

const base = 'materials'

const authHeaders = () => ({
  headers: { 'Authorization': 'Bearer ' + getToken() }
})

const jsonConfig = () => ({
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + getToken(),
  }
})

// ── Materials CRUD ──

export async function getMaterials(params) {
  const { data } = await http.get(base, { ...authHeaders(), params })
  return data
}

export async function getMaterialById(id) {
  const { data } = await http.get(`${base}/${id}`, authHeaders())
  return data
}

export async function createMaterial(payload) {
  const { data } = await http.post(base, payload, jsonConfig())
  return data
}

export async function updateMaterial(payload) {
  const { data } = await http.patch(`${base}/${payload.id}`, payload, jsonConfig())
  return data
}

export async function deleteMaterial(id) {
  const { data } = await http.delete(`${base}/${id}`, jsonConfig())
  return data
}

// ── Material photo ──

export async function uploadMaterialPhoto(id, file) {
  const { data } = await http.patch(`${base}/${id}/photo`, file, {
    headers: {
      'Content-Type': file.type,
      'Authorization': 'Bearer ' + getToken(),
    }
  })
  return data
}

// ── Stock ──

export async function adjustStock(id, payload) {
  const { data } = await http.post(`${base}/${id}/stock`, payload, jsonConfig())
  return data
}

export async function getStockMovements(id, params) {
  const { data } = await http.get(`${base}/${id}/stock/movements`, { ...authHeaders(), params })
  return data
}

export async function getLowStockMaterials() {
  const { data } = await http.get(`${base}/stock/low`, authHeaders())
  return data
}

export async function getLowStockCount() {
  const { data } = await http.get(`${base}/stock/count`, authHeaders())
  return data
}

// ── Categories ──

export async function getMaterialCategories() {
  const { data } = await http.get(`${base}/categories`, authHeaders())
  return data
}

export async function getMaterialCategoryById(id) {
  const { data } = await http.get(`${base}/categories/${id}`, authHeaders())
  return data
}

export async function createMaterialCategory(payload) {
  const { data } = await http.post(`${base}/categories`, payload, jsonConfig())
  return data
}

export async function updateMaterialCategory(payload) {
  const { data } = await http.patch(`${base}/categories/${payload.id}`, payload, jsonConfig())
  return data
}

export async function deleteMaterialCategory(id) {
  const { data } = await http.delete(`${base}/categories/${id}`, jsonConfig())
  return data
}

// ── Reports ──

export async function getMaterialUsageReport(startDate, endDate) {
  const params = new URLSearchParams()
  startDate && params.append('startDate', startDate.toISOString())
  endDate && params.append('endDate', endDate.toISOString())

  const { data } = await http.get(`${base}/reports/usage`, { ...authHeaders(), params })
  return data
}

export async function getMaterialSummary(startDate, endDate) {
  const params = new URLSearchParams()
  startDate && params.append('startDate', startDate.toISOString())
  endDate && params.append('endDate', endDate.toISOString())

  const { data } = await http.get(`${base}/reports/summary`, { ...authHeaders(), params })
  return data
}
